module.exports = __webpack_public_path__ + "media/images/review/reviewer-ico-4204fb12b3ae27c8e3ee85f6a672ddf0.svg";